{
  "entry": {
    "title": "आदेश प्रविष्टि",
    "subtitle": "कम्प्यूटरीकृत प्रदाता आदेश प्रविष्टि (CPOE)",
    "searchSection": {
      "title": "आदेश खोजें और जोड़ें",
      "cosignNotice": "आपके आदेशों को सक्रिय करने से पहले उपस्थित चिकित्सक के सह-हस्ताक्षर की आवश्यकता होगी।"
    },
    "pending": {
      "title": "लंबित आदेश",
      "clearAll": "सभी साफ़ करें",
      "collapseAria": "विवरण संक्षिप्त करें",
      "expandAria": "विवरण विस्तार करें",
      "removeAria": "आदेश हटाएँ",
      "startDateTime": "आरंभ दिनांक/समय",
      "ariaStartDate": "आदेश आरंभ दिनांक",
      "ariaStartTime": "आदेश आरंभ समय",
      "clinicalIndication": "नैदानिक संकेत",
      "clinicalIndicationPlaceholder": "आदेश का कारण…",
      "specialInstructions": "विशेष निर्देश",
      "specialInstructionsPlaceholder": "निष्पादन विभाग के लिए अतिरिक्त निर्देश…",
      "diagnosisLabel": "निदान (ICD-10)",
      "diagnosisPlaceholder": "ICD-10 निदान कोड खोजें…",
      "noActiveEncounter": "कोई सक्रिय मुलाकात नहीं — आदेश नहीं दिए जा सकते।",
      "placing": "भेजा जा रहा है…",
      "placeAll": "सभी आदेश भेजें ({{count}})"
    },
    "active": {
      "title": "सक्रिय आदेश",
      "loading": "आदेश लोड हो रहे हैं…",
      "emptyAll": "इस रोगी के लिए कोई आदेश नहीं मिला।",
      "emptyFiltered": "कोई {{type}} आदेश नहीं मिला।",
      "columns": {
        "orderNumber": "आदेश #",
        "name": "नाम",
        "type": "प्रकार",
        "priority": "प्राथमिकता",
        "status": "स्थिति",
        "orderedBy": "आदेशकर्ता",
        "orderedDate": "आदेश दिनांक",
        "actions": "क्रियाएँ"
      },
      "external": "बाहरी",
      "externalTitle": "{{source}} से बाहरी आदेश",
      "externalTitleWithId": "{{source}} से बाहरी आदेश (#{{id}})",
      "providerPlaceholder": "प्रदाता #{{id}}",
      "actions": {
        "complete": "पूर्ण करें",
        "cancel": "रद्द करें",
        "completeTooltip": "आदेश पूर्ण करें",
        "cancelTooltip": "आदेश रद्द करें"
      }
    },
    "cancelDialog": {
      "title": "आदेश रद्द करें",
      "prompt": "{{orderName}} को रद्द करने का कारण बताएँ।",
      "placeholder": "रद्द करने का कारण (आवश्यक)…",
      "goBack": "वापस जाएँ",
      "confirm": "रद्द करने की पुष्टि करें"
    },
    "toast": {
      "cancelSuccess": "आदेश सफलतापूर्वक रद्द किया गया",
      "cancelError": "आदेश रद्द करने में विफल",
      "completeSuccess": "आदेश को पूर्ण के रूप में चिह्नित किया गया",
      "completeError": "आदेश पूर्ण करने में विफल",
      "noActiveEncounter": "इस रोगी के लिए कोई सक्रिय मुलाकात नहीं मिली। कृपया पहले मुलाकात बनाएँ।",
      "placedSuccess_one": "{{count}} आदेश सफलतापूर्वक भेजा गया",
      "placedSuccess_other": "{{count}} आदेश सफलतापूर्वक भेजे गए",
      "medicationFieldsRequired_one": "{{names}} को निर्धारित करने से पहले खुराक, मार्ग और आवृत्ति आवश्यक है",
      "medicationFieldsRequired_other": "{{count}} दवाओं के लिए खुराक, मार्ग और आवृत्ति आवश्यक है: {{names}}",
      "medicationNotInFormulary_one": "{{names}} फ़ॉर्मूलरी से जुड़ा नहीं है और एलर्जी, पारस्परिक क्रिया या खुराक की जाँच नहीं हो सकती — इसे दवा पृष्ठ से निर्धारित करें",
      "medicationNotInFormulary_other": "{{count}} दवाएँ फ़ॉर्मूलरी से जुड़ी नहीं हैं और जाँची नहीं जा सकतीं: {{names}} — इन्हें दवा पृष्ठ से निर्धारित करें",
      "placedError_one": "{{count}} आदेश भेजने में विफल",
      "placedError_other": "{{count}} आदेश भेजने में विफल",
      "orderSetApplied": "{{name}} से {{count}} आदेश जोड़े गए — हस्ताक्षर से पहले समीक्षा करें"
    }
  },
  "catalog": "आदेश सूची",
  "orderedBy": "आदेशकर्ता",
  "orderedDate": "आदेश तिथि",
  "scheduledDate": "निर्धारित तिथि",
  "completedDate": "पूर्णता तिथि",
  "lab": "प्रयोगशाला",
  "imaging": "इमेजिंग",
  "medication": "दवा",
  "procedure": "प्रक्रिया",
  "consultation": "परामर्श",
  "priority": {
    "label": "प्राथमिकता",
    "values": {
      "stat": "STAT",
      "asap": "ASAP",
      "urgent": "तत्काल",
      "routine": "सामान्य",
      "scheduled": "निर्धारित",
      "prn": "PRN"
    }
  },
  "status": {
    "label": "आदेश स्थिति",
    "values": {
      "draft": "प्रारूप",
      "pending": "लंबित",
      "pendingCosign": "सह-हस्ताक्षर लंबित",
      "signed": "हस्ताक्षरित",
      "sent": "भेजा गया",
      "active": "सक्रिय",
      "ordered": "आदेशित",
      "inProgress": "प्रगति में",
      "holdForVerify": "सत्यापन हेतु रोक",
      "completed": "पूर्ण",
      "cancelled": "रद्द",
      "discontinued": "बंद",
      "archived": "संग्रहीत",
      "pendingClarification": "स्पष्टीकरण प्रतीक्षित",
      "suspended": "निलंबित",
      "unknown": "अज्ञात"
    }
  },
  "entryFields": {
    "searchPlaceholder": "आदेश खोजें (लैब, इमेजिंग, दवा, प्रक्रिया)…",
    "frequency": "आवृत्ति",
    "dose": "मात्रा",
    "route": "देने का मार्ग",
    "indication": "संकेत",
    "duration": "अवधि",
    "comments": "टिप्पणियाँ",
    "signOrder": "आदेश पर हस्ताक्षर",
    "holdOrder": "आदेश रोकें",
    "frequencyOptions": {
      "stat": "STAT",
      "prn": "PRN",
      "bid": "BID",
      "tid": "TID",
      "qid": "QID",
      "qd": "QD",
      "qhs": "QHS",
      "ac": "AC",
      "pc": "PC"
    }
  },
  "catalogPage": {
    "title": "आदेश सूची",
    "searchPlaceholder": "नाम, कोड या पर्यायवाची से खोजें…",
    "categories": "श्रेणियाँ",
    "favorites": "पसंदीदा",
    "recentlyUsed": "हाल में प्रयुक्त",
    "restricted": "प्रतिबंधित",
    "searchCatalog": "सूची में खोजें",
    "tabs": {
      "all": "सभी",
      "lab": "लैब",
      "imaging": "इमेजिंग",
      "medication": "दवा",
      "procedure": "प्रक्रिया",
      "consultation": "परामर्श"
    },
    "columns": {
      "orderName": "आदेश नाम",
      "code": "कोड",
      "category": "श्रेणी",
      "description": "विवरण",
      "defaultPriority": "डिफ़ॉल्ट प्राथमिकता"
    },
    "details": {
      "orderCode": "आदेश कोड",
      "category": "श्रेणी",
      "defaultPriority": "डिफ़ॉल्ट प्राथमिकता",
      "status": "स्थिति",
      "cptCode": "CPT कोड",
      "loincCode": "LOINC कोड",
      "synonyms": "पर्यायवाची",
      "description": "विवरण",
      "active": "सक्रिय",
      "inactive": "निष्क्रिय"
    },
    "loading": "सूची लोड हो रही है…",
    "loadError": "आदेश सूची लोड नहीं हो सकी",
    "emptyResults": "मानदंडों से मेल खाता कोई आदेश नहीं मिला।",
    "pagination": "कुल {{total}} में से {{from}}-{{to}} दिखाए जा रहे हैं",
    "pageIndicator": "{{totalPages}} में से पृष्ठ {{page}}",
    "favoriteAdd": "पसंदीदा में जोड़ें",
    "favoriteRemove": "पसंदीदा से हटाएँ",
    "favoriteAdded": "पसंदीदा में जोड़ा गया",
    "favoriteRemoved": "पसंदीदा से हटा दिया गया"
  },
  "cosign": {
    "title": "आदेश सह-हस्ताक्षर कतार",
    "requiresCosign": "सह-हस्ताक्षर आवश्यक",
    "cosignedBy": "सह-हस्ताक्षरकर्ता",
    "cosignDeadline": "सह-हस्ताक्षर समय-सीमा",
    "queueEmpty": "किसी भी आदेश को सह-हस्ताक्षर की आवश्यकता नहीं है।",
    "pendingCount": "{{count}} लंबित",
    "loading": "सह-हस्ताक्षर कतार लोड हो रही है…",
    "loadError": "सह-हस्ताक्षर कतार लोड नहीं हो सकी।",
    "columns": {
      "patient": "रोगी",
      "order": "आदेश",
      "type": "प्रकार",
      "orderingProvider": "आदेशकर्ता चिकित्सक",
      "priority": "प्राथमिकता",
      "orderedDate": "आदेश तिथि",
      "action": "क्रिया"
    },
    "actions": {
      "cosign": "सह-हस्ताक्षर"
    },
    "toast": {
      "success": "आदेश पर सह-हस्ताक्षर सफल",
      "error": "आदेश पर सह-हस्ताक्षर विफल"
    },
    "cosigningAs": "{{name}} के रूप में सह-हस्ताक्षर"
  },
  "sets": {
    "title": "आदेश सेट",
    "newOrderSet": "नया आदेश सेट",
    "addItem": "आइटम जोड़ें",
    "requiredItem": "अनिवार्य",
    "optionalItem": "वैकल्पिक",
    "editMode": "संपादन मोड",
    "published": "प्रकाशित",
    "draft": "प्रारूप",
    "archived": "संग्रहीत",
    "versionNotes": "संस्करण टिप्पणियाँ",
    "createTitle": "नया आदेश सेट बनाएँ",
    "fields": {
      "name": "नाम",
      "category": "श्रेणी",
      "specialty": "विशेषज्ञता",
      "description": "विवरण"
    },
    "placeholders": {
      "name": "उदा., सीने में दर्द जाँच",
      "categorySelect": "श्रेणी चुनें…",
      "specialty": "उदा., आपातकालीन चिकित्सा",
      "description": "संक्षिप्त विवरण…",
      "search": "आदेश सेट खोजें…"
    },
    "categories": {
      "chestPain": "सीने में दर्द",
      "sepsis": "सेप्सिस",
      "postOp": "ऑपरेशन के बाद",
      "admission": "भर्ती",
      "discharge": "डिस्चार्ज",
      "other": "अन्य"
    },
    "statusFilter": {
      "all": "सभी स्थितियाँ",
      "active": "सक्रिय",
      "draft": "प्रारूप",
      "archived": "संग्रहीत"
    },
    "columns": {
      "name": "नाम",
      "category": "श्रेणी",
      "specialty": "विशेषज्ञता",
      "items": "आइटम",
      "status": "स्थिति",
      "version": "संस्करण",
      "actions": "क्रियाएँ"
    },
    "itemColumns": {
      "seq": "क्रम",
      "type": "प्रकार",
      "item": "आइटम",
      "priority": "प्राथमिकता",
      "required": "अनिवार्य"
    },
    "itemTypes": {
      "order": "आदेश",
      "sectionHeader": "अनुभाग शीर्षक",
      "instruction": "निर्देश"
    },
    "actions": {
      "publish": "प्रकाशित करें",
      "archive": "संग्रहीत करें",
      "cancel": "रद्द करें",
      "create": "बनाएँ",
      "removeItem": "आइटम हटाएँ"
    },
    "loading": "आदेश सेट लोड हो रहे हैं…",
    "loadError": "आदेश सेट लोड नहीं हो सके",
    "emptyResults": "कोई आदेश सेट नहीं मिला।",
    "expandLoading": "आइटम लोड हो रहे हैं…",
    "expandEmpty": "इस आदेश सेट में कोई आइटम नहीं है।",
    "validationRequired": "नाम, श्रेणी और विशेषज्ञता आवश्यक हैं",
    "toast": {
      "created": "आदेश सेट बनाया गया",
      "createError": "आदेश सेट बनाने में विफल",
      "published": "आदेश सेट प्रकाशित",
      "publishError": "आदेश सेट प्रकाशित करने में विफल",
      "archived": "आदेश सेट संग्रहीत",
      "archiveError": "आदेश सेट संग्रहीत करने में विफल",
      "itemRemoved": "आइटम हटाया गया",
      "itemRemoveError": "आइटम हटाने में विफल"
    },
    "versionBadge": "v{{version}}"
  },
  "search": {
    "placeholder": "आदेश खोजें (लैब, इमेजिंग, दवा, प्रक्रिया)…",
    "noResults": "\"{{query}}\" के लिए कोई आदेश नहीं मिला",
    "categories": {
      "all": "सभी",
      "lab": "लैब",
      "imaging": "इमेजिंग",
      "med": "दवा",
      "procedure": "प्रक्रिया",
      "consultation": "परामर्श"
    },
    "addAll": "सभी {{count}} जोड़ें"
  },
  "worklist": {
    "title": "आदेश कार्यसूची",
    "countBadge": "{{count}} आदेश",
    "loading": "आदेश लोड हो रहे हैं…",
    "loadError": "आदेश लोड नहीं हो सके। कृपया पुनः प्रयास करें।",
    "empty": "वर्तमान फ़िल्टर से कोई आदेश मेल नहीं खाता।",
    "typeLabel": "आदेश प्रकार",
    "allOption": "सभी",
    "columns": {
      "patient": "रोगी",
      "order": "आदेश",
      "type": "प्रकार",
      "priority": "प्राथमिकता",
      "status": "स्थिति",
      "ordered": "आदेश तिथि"
    }
  }
}
